import styled from "styled-components";

export const FilterSelectStyled = styled.div`
  width: 140px;
  height: 35px;
  margin-right: 10px;
`;
